'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { getDisplaySymbol } from '@flipster/features/src/shared/snapshot/utils';
import { numberFormatter } from '@flipster/utils/num';

import { symbolDisplayPriceBunja, tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';

export const BrowserTitle = () => {
  const { symbol, symbolInfoAtom } = useBunja(tradeSymbolBunja);
  const symbolInfo = useAtomValue(symbolInfoAtom);
  const { throttledDisplayPriceAtom, displayPricePrecisionAtom } = useBunja(symbolDisplayPriceBunja);
  const displayPrice = useAtomValue(throttledDisplayPriceAtom);
  const displayPricePrecision = useAtomValue(displayPricePrecisionAtom);

  const isSpot = symbolInfo?.isSpot;

  useEffect(() => {
    if (!displayPrice) return;

    const formattedDisplayPrice = numberFormatter(displayPrice, {
      method: 'round-half-up',
      precision: displayPricePrecision,
      toFixed: true,
    });
    const displaySymbol = symbolInfo ? getDisplaySymbol(symbolInfo) : symbol;
    document.title = `${formattedDisplayPrice} | Trade ${displaySymbol} | Flipster ${isSpot ? 'Spot' : 'Perpetual'} Trading`;
  }, [symbol, symbolInfo, displayPricePrecision, displayPrice, isSpot]);

  return null;
};
